export default ({ obs, spo2Scale2 }) => {
  let score = 0
  let has3 = false

  if (
    !obs?.respRate ||
    !obs?.spo2 ||
    !obs?.bpSys ||
    !obs?.heartRate ||
    !obs?.avpu ||
    !obs?.temp
  ) {
    return false
  }

  // Resp Rate
  if (obs?.respRate >= 9 && obs?.respRate <= 11) score += 1
  if (obs?.respRate >= 21 && obs?.respRate <= 24) score += 2
  if (obs?.respRate <= 8 || obs?.respRate >= 25) {
    score += 3
    has3 = true
  }

  // Supplemental oxygen — 'Yes'/'No' select; older records may hold booleans
  const onOxygen = obs?.suppO2 === 'Yes' || obs?.suppO2 === true

  // SPO2
  if (onOxygen) score += 2
  if (spo2Scale2) {
    // SCALE 2
    if (obs?.spo2 <= 83) {
      score += 3
      has3 = true
    }
    if (obs?.spo2 >= 84 && obs?.spo2 <= 85) score += 2
    if (obs?.spo2 >= 86 && obs?.spo2 <= 87) score += 1
    if (onOxygen) {
      // SCALE 2 on Oxygen
      if (obs?.spo2 >= 93 && obs?.spo2 <= 94) score += 1
      if (obs?.spo2 >= 95 && obs?.spo2 <= 96) score += 2
      if (obs?.spo2 >= 97) {
        score += 3
        has3 = true
      }
    }
  } else {
    // SCALE 1
    if (obs?.spo2 >= 94 && obs?.spo2 <= 95) score += 1
    if (obs?.spo2 >= 92 && obs?.spo2 <= 93) score += 2
    if (obs?.spo2 <= 91) {
      score += 3
      has3 = true
    }
  }

  // SYSTOLIC BP
  if (obs?.bpSys >= 220 || obs?.bpSys <= 90) {
    score += 3
    has3 = true
  } else if (obs?.bpSys >= 101 && obs?.bpSys <= 110) {
    score += 1
  } else if (obs?.bpSys >= 91 && obs?.bpSys <= 100) {
    score += 2
  }

  // PULSE
  if (obs?.heartRate >= 41 && obs?.heartRate <= 50) {
    score += 1
  } else if (obs?.heartRate <= 40 || obs?.heartRate >= 131) {
    score += 3
    has3 = true
  } else if (obs?.heartRate >= 91 && obs?.heartRate <= 110) {
    score += 1
  } else if (obs?.heartRate >= 111 && obs?.heartRate <= 130) {
    score += 2
  }

  //AVPU
  if (obs?.avpu && obs.avpu !== 'Alert') {
    score += 3
    has3 = true
  }
  //TEMPERATURE
  if (obs?.temp >= 35.1 && obs?.temp <= 36) {
    score += 1
  } else if (obs?.temp <= 35) {
    score += 3
    has3 = true
  } else if (obs?.temp >= 38.1 && obs?.temp <= 39) {
    score += 1
  } else if (obs?.temp >= 39.1) score += 2

  // Colour logic
  let color
  if (score >= 7)
    color = '#dc0000' // Red
  else if (score >= 5)
    color = '#fd8c00' // Orange
  else if (has3)
    color = '#fdc500' // Yellow
  else color = '#00ac46' // Green

  // Text Color Logic
  let textColor
  if (score >= 7)
    textColor = '#fff' // Red
  else if (score >= 5)
    textColor = 'inherit' // Orange
  else if (has3)
    textColor = 'inherit' // Yellow
  else textColor = '#fff' // Green

  return { score, color, textColor }
}
